var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.item)?_c('v-chip',{attrs:{"color":_setup.item.color}},[_vm._v(" "+_vm._s(_setup.item.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }